import fiscalInstance from '../instance'

export const getCashRegisterCloseDocumentation = () => {
	return fiscalInstance.get('/cashRegisterClose/documentation/zip', { responseType: 'arraybuffer' })
}
